var _defs, _path, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewLogo = function SvgNewLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "New-Logo",
    width: 112.002,
    height: 34.001,
    viewBox: "0 0 112.002 34.001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4500"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Text",
    d: "M19881.6,7259.961v-13.945h-3.615v12.047h-6.027v-20.031a5.352,5.352,0,0,1,5.3-5.352h4.6a5.321,5.321,0,0,1,5.3,5.352v21.4a2.785,2.785,0,0,1-2.764,3.055C19881.859,7262.484,19881.6,7260.648,19881.6,7259.961Zm-3.615-23.437v6.1h3.615v-6.1c-.111-.773-1.012-1.18-1.832-1.18A1.643,1.643,0,0,0,19877.986,7236.523Zm-24.092,22.906v-21.4a5.356,5.356,0,0,1,5.32-5.352h4.611a5.339,5.339,0,0,1,5.289,5.352v20.031h-6.012v-12.047h-3.6v13.945c0,.688-.3,2.523-2.812,2.523A2.82,2.82,0,0,1,19853.895,7259.43Zm5.609-22.906v6.1h3.6v-6.1a1.617,1.617,0,0,0-1.752-1.18A1.729,1.729,0,0,0,19859.5,7236.523Zm41.561,22.172-4.58-12.32-.1.109v12.188h-5.785v-28.266c.064-2.7,5.85-2.43,5.785,0v14.25l.436-.289,4.66-10.7,5.432-.039-4.838,11.367,5.16,13.7Zm-60.492-.125a5.339,5.339,0,0,1-5.336-5.328v-15.211a5.349,5.349,0,0,1,5.336-5.352h4.564a5.332,5.332,0,0,1,5.3,5.352c0,1.227.145,2.492.145,3.664a2.617,2.617,0,0,1-.145.852l-.273.844a2.856,2.856,0,0,1-4.082,1.047,3.324,3.324,0,0,1-1.35-1.789l-.1-.953c0-1.7.1-3.523.1-5.3a1.294,1.294,0,0,0-1.285-1.328h-1.158a1.316,1.316,0,0,0-1.3,1.328v17.43a1.313,1.313,0,0,0,1.3,1.313h1.158a1.29,1.29,0,0,0,1.285-1.312v-5.859h5.705v5.273a5.322,5.322,0,0,1-5.3,5.328Z",
    transform: "translate(-19795.234 -7228.483)",
    fill: "#0d1026"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Caak-Logo",
    transform: "translate(0 1.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "download_28",
    d: "M10.353,0H21.647A10.353,10.353,0,0,1,32,10.353V21.647A10.353,10.353,0,0,1,21.647,32H10.353A10.353,10.353,0,0,1,0,21.647V10.353A10.353,10.353,0,0,1,10.353,0Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M-1405.777-1439.751a11.4,11.4,0,0,1,13.909-11.081c5.778,1.551,8.816,6.29,7.148,8.429s-3.3,1.283-5.607-.214-5.649-4.064-6.933-3.893-1.926,1.048-1.926,4.514-.418,7.957.963,8.535c1.519.636,1.69.556,4.6-1.369s6-5.049,8.474-2.867c2.621,2.31-.69,5.836-4.451,8.086C-1394.821-1426.488-1405.777-1429.825-1405.777-1439.751Z",
    transform: "translate(1410.994 1455.809)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/New-Logo.d84d06f13314dfb72b5193e41baee6c3.svg";
export { ForwardRef as ReactComponent };